import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { CardWrapper } from './components/card-wrapper';
import { SelectStats } from './components/select-stats';
import { CompanyStatsProvider } from './context/provider';
import * as Styled from './styles';
import * as SX from './sx';
import type { CompanyLocationStatsProps as Props } from './types';

export const CompanyLocationStats = memo(
  ({
    className,
    employees,
    offices,
    hoveredItem,
    handleChangeStats,
    statsType,
  }: Props) => {
    return (
      <CompanyStatsProvider
        value={{
          employees,
          offices,
          hoveredItem,
          statsType,
          handleChangeStats,
        }}
      >
        <Styled.Wrapper
          className={classnames('CompanyLocationStats', className)}
          sx={SX.root}
          variant="outlined"
        >
          <SelectStats />
          <CardWrapper />
        </Styled.Wrapper>
      </CompanyStatsProvider>
    );
  }
);

CompanyLocationStats.displayName = 'CompanyLocationStats';
